<template>
    <div class="main situation videoSituation">
        <div style="height: 100%">
            <div class="leftContent">
                <el-collapse v-model="activeNamesFirst">
                    <el-collapse-item :title="relationVideosTitle" name="1">
                        <div class="buttonZone">
                            <el-button type="primary" @click="videoPlayStatus=!videoPlayStatus">全部播放/暂停</el-button>
                            <el-button type="warning" @click="muted=!muted">全部静音/取消</el-button>
                        </div>
                        <ul class="videoUl">
                            <li v-for="(item,index) in relationVideos" :key="index">
                                <video class="myVideo" :src="item" type="video/mp4" :muted="muted" controls="controls" width="320" height="240" preload loop></video>
                            </li>
                        </ul>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-model="activeNamesSecond">
                    <el-collapse-item :title="customerVideosTitle" name="1">
                        <div class="buttonZone">
                            <el-button type="primary" @click="cuVideoPlayStatus=!cuVideoPlayStatus">全部播放/暂停</el-button>
                            <el-button type="warning" @click="cuMuted=!cuMuted">全部静音/取消</el-button>
                        </div>
                        <ul class="videoUl">
                            <li v-for="(item,index) in customerVideos" :key="index">
                                <video class="cuMyVideo" :src="item" type="video/mp4" :muted="cuMuted" controls="controls" preload loop></video>
                            </li>
                        </ul>
                    </el-collapse-item>
                </el-collapse>
                <el-collapse v-model="activeNamesSecond">
                    <el-collapse-item :title="directorVideosTitle" name="1">
                        <div class="buttonZone">
                            <el-button type="primary" @click="diVideoPlayStatus=!diVideoPlayStatus">全部播放/暂停</el-button>
                            <el-button type="warning" @click="diMuted=!diMuted">全部静音/取消</el-button>
                        </div>
                        <ul class="videoUl">
                            <li v-for="(item,index) in directorVideos" :key="index">
                                <video class="diMyVideo" :src="item" type="video/mp4" :muted="diMuted" controls="controls" preload loop></video>
                            </li>
                        </ul>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <div class="bottomBtns">
            <el-button plain @click="close">关闭</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "videos",
    props: ["videosId"],
    data() {
        return {
            activeNamesFirst: ['1'],
            activeNamesSecond: ['1'],
            activeNamesThird: ['1'],
            videoPlayStatus: false,
            cuVideoPlayStatus: false,
            diVideoPlayStatus: false,
            muted: false,
            cuMuted: false,
            diMuted: false,
            autoplay: false,
            directorVideos: [], //接警人视频列表
            customerVideos: [], //报案人视频列表
            relationVideos: [], //混合视频列表
            directorVideosTitle: '',
            customerVideosTitle: '',
            relationVideosTitle: '',
            videoResult: {},

        }
    },
    watch: {
        videoPlayStatus(val) {
            if (val) {
                this.videoPlay();
            } else {
                this.videoPause();
            }
        },
        cuVideoPlayStatus(val) {
            if (val) {
                this.cuVideoPlay();
            } else {
                this.cuVideoPause();
            }
        },
        diVideoPlayStatus(val) {
            if (val) {
                this.diVideoPlay();
            } else {
                this.diVideoPause();
            }
        }
    },
    created() {

    },
    mounted() {
        this.getVideos();
    },
    methods: {
        getVideos() {
            this.$axios.post(`/admin/appointment/${this.videosId}/video/list`).then(res => {
                console.log(res.data)
                let { code, data, msg } = res.data;
                if(code == 0) {
                    this.directorVideos = data.directorVideos;
                    this.customerVideos = data.customerVideos;
                    this.relationVideos = data.relationVideos;
                    this.directorVideosTitle = this.directorVideos == null ? '接警人视频-视频数量：0' : '接警人视频-视频数量：' + this.directorVideos.length;
                    this.relationVideosTitle = this.relationVideos == null ? '报案人视频-视频数量：0' :  '报案人视频-视频数量：' + this.relationVideos.length;
                    this.customerVideosTitle = this.customerVideos == null ? '混合视频-视频数量：0' :  '混合视频-视频数量：' + this.customerVideos.length;
                } else {
                    this.$message.error(msg);
                }
            })
        },
        videoPlay() {
            var videos = document.getElementsByClassName('myVideo');
            videos = Array.from(videos);
            videos.forEach((element, index) => {
                if(!element.ended){
                    element.play();
                }
            })
        },
        videoPause() {
            var videos = document.getElementsByClassName('myVideo');
            videos = Array.from(videos);
            videos.forEach(element => {
                element.pause();
            })
        },
        cuVideoPlay() {
            var videos = document.getElementsByClassName('cuMyVideo');
            videos = Array.from(videos);
            videos.forEach(element => {
                if(!element.ended){
                    element.play();
                }
            })
        },
        cuVideoPause() {
            var videos = document.getElementsByClassName('cuMyVideo');
            videos = Array.from(videos);
            videos.forEach(element => {
                element.pause();
            })
        },
        diVideoPlay() {
            var videos = document.getElementsByClassName('diMyVideo');
            videos = Array.from(videos);
            videos.forEach(element => {
                if(!element.ended){
                    element.play();
                }
            })
        },
        diVideoPause() {
            var videos = document.getElementsByClassName('diMyVideo');
            videos = Array.from(videos);
            videos.forEach(element => {
                element.pause();
            })
        },

        close() {
            this.$emit('hideVideos');
        },

    }
}
</script>

<style lang="scss" scoped>
.main {
    display: flex;
    background: #fff;
    flex-direction: row;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    z-index: 100;
    flex-direction: column;
    box-sizing: border-box;

    .leftContent {
        box-sizing: border-box;
        text-align: left;
        width: calc(100%);
        padding-bottom: 30px;

        .buttonZone {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            box-sizing: border-box;
            padding: 5px;
            padding-bottom: 0px;
        }

        .videoUl {
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 10px 10px 10px;

            li {
                flex: 1;
                margin: 10px;
                max-height: 530px;

                video {
                    width: 100%;
                    height: 530px;
                    background: #000;
                }
            }
        }
    }

    .bottomBtns {
        width: 100%;
        position: fixed;
        left: 0px;
        bottom: 0px;
        background: #ccc;
        margin-bottom: 0px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// videos.vue?eaeb290c